import React from 'react';

export default function Loading() {

    return (

            <div style={{ 
                    display: "flex", 
                    alignItems: "center",
                    justifyContent: "center", 
                    height:"100vh",
                    flexDirection: "column"
                  }}>
                

                  <h1>Loading....</h1>

            </div>
    );

}


